'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _latinAccentChars = require('./latinAccentChars');

var _latinAccentChars2 = _interopRequireDefault(_latinAccentChars);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validCCTLD = require('./validCCTLD');

var _validCCTLD2 = _interopRequireDefault(_validCCTLD);

var _validGTLD = require('./validGTLD');

var _validGTLD2 = _interopRequireDefault(_validGTLD);

var _validPunycode = require('./validPunycode');

var _validPunycode2 = _interopRequireDefault(_validPunycode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validAsciiDomain = (0, _regexSupplant2.default)(/(?:(?:[\-a-z0-9#{latinAccentChars}]+)\.)+(?:#{validGTLD}|#{validCCTLD}|#{validPunycode})/gi, { latinAccentChars: _latinAccentChars2.default, validGTLD: _validGTLD2.default, validCCTLD: _validCCTLD2.default, validPunycode: _validPunycode2.default }); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validAsciiDomain;
module.exports = exports['default'];